// extracted by mini-css-extract-plugin
module.exports = {"note":"styles_note__3d2a-","button":"styles_button__16iMo","subBlockOverRide":"styles_subBlockOverRide__1X_nf","thinSection":"styles_thinSection__362hO"};